import {
  PropertyStatusChecker,
  type PropertyStatusConfiguration,
  type Status,
} from '@/features/domaine/property-status'
import { shallowRef } from 'vue'

export function usePropertyStatusFieldState<TModel extends object, TContext, TGlobalModel = TModel>(
  configuration: PropertyStatusConfiguration<TModel, TContext, TGlobalModel>,
) {
  const checker = new PropertyStatusChecker(configuration)
  const state = shallowRef<Status<TModel>>({})

  function checkStatus(modele: TModel, context: TContext) {
    state.value = checker.checkStatus(modele, context)
  }

  return { state, checkStatus }
}

